export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      fill="#8B8B8B"
      d="M6.571 1.571a5 5 0 013.826 8.22l3.906 3.906a.429.429 0 01-.558.648l-.048-.042-3.906-3.906a5 5 0 11-3.22-8.826zm0 .858a4.143 4.143 0 100 8.285 4.143 4.143 0 000-8.285z"
    />
  </svg>
)
